import { useRef, useState } from 'react';
import { Button, Stack } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import { WPLeaderboardFormDialog } from '~/components/forms/WPLeaderboardForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';
import { useActivateWPLeaderboardMutation } from '~/lib/api/modules/WPLeaderboard/hooks/useActivateWPLeaderboardMutation';

export type IWPLeaderboardProps = IContainerProps & {
  appId: string;
};

export const WPLeaderboard: React.FC<IWPLeaderboardProps> = (props) => {
  const { sx, appId } = props;
  const { t } = useTranslation();
  const appQuery = useAppQuery({ appId });
  const enableAppWPLeaderboardMutation = useActivateWPLeaderboardMutation();
  const [leaderboardFormDialogOpened, setLeaderboardFormDialogOpened] =
    useState(false);

  const app = appQuery.data;

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const leaderboardWpUrl = app?.settings?.press?.env?.leaderboardWpUrl;
  const autoLoginToken = app?.credentials?.leaderboardWp?.autologinToken;
  const iframeUrl =
    leaderboardWpUrl && autoLoginToken
      ? `${leaderboardWpUrl}/wp-admin/?${new URLSearchParams({
          crowdaa_autologin: autoLoginToken,
        })}`
      : undefined;

  return (
    <>
      <WPLeaderboardFormDialog
        opened={leaderboardFormDialogOpened}
        onClose={() => setLeaderboardFormDialogOpened(false)}
        appId={appId}
      />

      <ContentBlock sx={sx} draft={!!iframeUrl}>
        {iframeUrl ? (
          <ContentBlock.Iframe
            ref={iframeRef}
            src={iframeUrl}
            title={t('WPLeaderboard.iframeTitle')}
          />
        ) : (
          <ContentBlock.Empty title={t('WPLeaderboard.notConfigured.title')}>
            <Stack gap={3}>
              <div>
                <Button onClick={() => setLeaderboardFormDialogOpened(true)}>
                  {t('WPLeaderboard.notConfigured.actionLabel')}
                </Button>
              </div>
              {enableAppWPLeaderboardMutation.isError ? (
                <ErrorMessage error={enableAppWPLeaderboardMutation.error} />
              ) : null}
            </Stack>
          </ContentBlock.Empty>
        )}
      </ContentBlock>
    </>
  );
};
